import {Order} from 'grpc-bob/subscription_pb';
import {OrderStatus} from 'grpc-bob/enum_pb';
import {IPromotion, PackageWithPromotion} from '../state-management/app';
import {PROMOTION_STATUS} from '../constants/enum';


export function findActiveOrder(orders: Order.AsObject[]): Order.AsObject | null {
  const filtered = orders.filter((order) => order.status === OrderStatus.ORDER_STATUS_SUCCESSFULLY); //order must have status success

  if (filtered.length === 0) return null;

  let result = filtered[0];
  if (result.start && result.start.seconds) {
    for (let i = 1; i < filtered.length; i++) { //ignore 1st element
      if (filtered[i].start && result.start.seconds > filtered[i].start.seconds) result = filtered[i]; //find order that has smallest start date
    }
  }
  return result
}

export function getActualMoney(pack: PackageWithPromotion): number {
  const priceAfterCarried = pack.carriedOverAmount ? pack.price - pack.carriedOverAmount : pack.price;
  const priceAfterPromo = pack.isPromotionApplied ? pack.promoFinalPrice : priceAfterCarried;

  if (typeof priceAfterPromo !== "undefined") {
    return priceAfterPromo > 0 ? priceAfterPromo : 0
  }

  return priceAfterCarried;
}

export function resetPromotionOnPackage(packages: PackageWithPromotion[]): PackageWithPromotion[] {

  return packages.map((pack) => ({
    ...pack,
    isPromotionApplied: undefined,
    promoFinalPrice: undefined,
    promotionDiscountValue: undefined
  }))
}

export function conditionToStep(condition: boolean) {
  return condition ? 0 : 1
}

export function isPromotionValid(promotion: IPromotion) {
  return promotion.status === PROMOTION_STATUS.VALID
}

export async function delay(ms: number): Promise<undefined> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), ms)
  })
}

export function isOrderStillProcessing(status: OrderStatus){
  return (
    status === OrderStatus.ORDER_STATUS_SUCCESSFULLY ||
    status === OrderStatus.ORDER_STATUS_WAITING_FOR_PAYMENT ||
    status === OrderStatus.ORDER_STATUS_PROCESSING_PAYMENT
  )
}
